interface ISortable {
    sort: number | null | undefined
}

enum ESortResult {
    FIRST_PARAMETER_BEFORE = -1,
    EQUALS = 0,
    FIRST_PARAMETER_AFTER = 1,
}

export function sortFunction(first: ISortable, second: ISortable): ESortResult {
    if (first.sort === second.sort) {
        return ESortResult.EQUALS;
    }

    if (first.sort === null || first.sort === undefined) {
        return ESortResult.FIRST_PARAMETER_AFTER;
    }

    if (second.sort === null || second.sort === undefined) {
        return ESortResult.FIRST_PARAMETER_BEFORE;
    }

    if (first.sort < second.sort) {
        return ESortResult.FIRST_PARAMETER_BEFORE;
    } else if (first.sort > second.sort) {
        return ESortResult.FIRST_PARAMETER_AFTER;
    }

    return ESortResult.EQUALS;
}
